module.exports = __webpack_public_path__ + "img/kh28.43e2feef.png";